module.exports = __webpack_public_path__ + "static/media/sg1cr0.f413df98.png";